export const toggleMenu = () => ({
    type: 'TOGGLE_MENU',
});

export const hideMenu = () => ({
    type: 'HIDE_MENU',
});
